// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../redux/modules/actions';
import ActiveCustomers        from './ActiveCustomers';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
        fetchStatsGraphDataIfNeeded:  actions.fetchStatsGraphDataIfNeeded,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActiveCustomers);



// WEBPACK FOOTER //
// ./src/app/views/partner/activeCustomers/index.js